import Vue from 'vue';
import VueRouter from 'vue-router';
import api from './api/api';
import settings from './modules/settings';
// import store from './store/store.js'


const Home = () => import('./views/Home.vue');
const SiteError = () => import('./views/Error.vue');
const Login = () => import('./views/auth/Login.vue');
const Register = () => import('./views/auth/Register.vue');
const ForgotPassword = () => import('./views/auth/ForgotPassword');
const ViewBoards = () => import('./views/forum/ViewBoards.vue');
const ViewBoard = () => import('./views/forum/ViewBoard.vue');
const ViewTopic = () => import('./views/forum/ViewTopic.vue');
const CreateTopic = () => import('./views/forum/CreateTopic.vue');
const ViewTopicList = () => import('./views/forum/ViewTopicList.vue');
const Admin = () => import('./views/forum/Admin.vue');
const Member = () => import('./views/member/Member.vue');
const MemberEdit = () => import('./views/member/MemberEdit.vue');
const Messages = () => import('./views/messages/Messages.vue');
const AdvancedSearch = () => import('./views/forum/AdvancedSearch.vue');
const Static = () => import('./views/static/Static.vue');
const Wiki = () => import('./views/Wiki.vue');
const ViewPostList = () => import('./views/forum/ViewPostList.vue');
const Guidelines = () => import('./views/Guidelines.vue');


Vue.use(VueRouter);


function gotoPost(topicID, instr, routerNext) {

    if (instr === "last") {

        api.post(`/topics/${topicID}/latestPostInfo`, {
            topicID: parseInt(topicID),
            pageSize: settings.user.getPostsPerPage(),
            sortAscending: settings.user.getPostOrder() === 'asc'
        }).then((response) => {
            routerNext(`/topics/${topicID}/posts/${response.data.postID}`);
        }).catch(() => {
            routerNext();
        });
    }

    if (instr === "unread") {

        api.post(`/topics/${topicID}/firstUnreadPostInfo`, {
            topicID: parseInt(topicID),
            pageSize: settings.user.getPostsPerPage(),
            sortAscending: settings.user.getPostOrder() === 'asc'
        }).then((response) => {
            if (response.data.postID === 0) {
                routerNext();
            } else {
                routerNext(`/topics/${topicID}/posts/${response.data.postID}`);
            }
        }).catch(() => {
            routerNext();
        });

    }
}

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: Home },
        { path: '/error', component: SiteError },
        { path: '/login', component: Login },
        { path: '/register', component: Register },
        { path: '/forgotpass', component: ForgotPassword},
        { path: '/boards', component: ViewBoards },
        { path: '/boards/:id', component: ViewBoard, props: true },
        { path: '/topics/create/:referringBoardID?', component: CreateTopic, props: true, meta: { requiresAuth: true } },
        /*  TOPIC ROUTING:
            All routes below go to ViewTopic component:

            /topics/:id     => direct, 1st page
            /topics/:id?post=last       => get post id and redirect /topics/:id/posts/:postId
            /topics/:id?post=unread     => get post id and redirect /topics/:id/posts/:postId
            /topics/:id/posts/:postId   => gets page and passes it as param to component
        */
        {
            path: '/topics/:id',
            component: ViewTopic,
            props: true,
            beforeEnter: (to, from, next) => {
                // check for ?post=last or ?post=unread
                var postInstruction = to.query.post || null;
                if (postInstruction) {
                    gotoPost(to.params.id, postInstruction, next);
                } else {
                    next();
                }
            }
        },
        { path: '/topics/:id/posts/:postId',
            component: ViewTopic,
            name:'ViewTopic',
            props: true,
            beforeEnter: (to, from, next) => {
                api.post(`/posts/${to.params.postId}/page`, {
                     postID: parseInt(to.params.postId),
                     userPageSize: settings.user.getPostsPerPage(),
                     userSortAsc: settings.user.getPostOrder() === "asc"
                }).then((response) => {
                    to.params.requestedPage = response.data;
                    next();
                }).catch(() => {
                    to.params.requestedPage = 1;
                    next();
                });
            }
        },

        { path: '/topics/list/:topicListType', component: ViewTopicList, props: true },
        { path: '/posts/list/:postListType', component: ViewPostList, props: true },

        { path: '/admin', component: Admin, meta: { requiresAuth: true }},
        { path: '/members/:id', component: Member, props: true, meta: { requiresAuth: true }},
        { path: '/members/:id/edit', component: MemberEdit, props: true, meta: { requiresAuth: true }, beforeEnter: validateMemberEdit },
        { path: '/messages', component: Messages, meta: { requiresAuth: true }},
        { path: '/static/:staticPage', component: Static, props: true},
        { path: '/search', component: AdvancedSearch},
        { path: '/forum/reported', component: () => import('./views/forum/ReportedPosts.vue') },
        { path: '/search/topic', component: () => import('./views/forum/AdvancedSearchTopic.vue')},
        { path: '/search/post', component: () => import('./views/forum/AdvancedSearchPost.vue')},
        { path: '/search/attatchment', component: () => import('./views/forum/AdvancedSearchAttatchment.vue')},
        {
            path: '/attachments/:id',
            props: true,
            beforeEnter(to, from, next) {
                window.location = api.baseUrl() + '/attachments/' + to.params.id;
                return next(false); // doesn't seem to work
            }
        },
        { path: '/forum/login.html', redirect: '/login' },
        { path: '/guidelines', component: Guidelines },
        { path: '/forum/index.php', beforeEnter: (to, from, next) => {

            var ret = '/';

            // resolve known querystring params
            let action = getParam(to.query.act);
            let postID = getParam(to.query.pid);
            if (postID === null) postID = getParam(to.query.p);
            if (postID === null) postID = getParam(to.query.gopid);
            let topicID = getParam(to.query.showtopic);
            //let view = getParam(to.query.view);

            if (action !== null) {
                if (action === 'idx') ret = '/boards';
                if (action === 'boardules') ret = '/static/help';
                next(ret);
            }

            if (topicID !== null) {
                ret = '/topics/' + topicID;
                if (postID !== null) {
                    ret = ret + '/posts/' + postID;
                }
                next(ret);
            } else {

                // if we made it here, not sure what happened:
                // console.log('Redirect unresolved: ');
                // console.log(to);

                next('/');
            }
        }},
        { path: '/forum/*.html*', beforeEnter: (to, from, next) => {
            /*
                /forum/home.html
                /forum/convert-text-number-acc-t1796560.html
                /forum/Access-Code-Archive-f34.html
                /forum/Access-Code-Archive-f34.html?hl=someword
            */
            var ret = '/';
            if (to.path === "/forum/home.html") next(ret);

            var token = to.path;
            //var querystring = getQuerystring(token);

            token = stripQuerystring(token);
            token = token.replace('.html', '');
            var tPos = token.lastIndexOf('t');
            var fPos = token.lastIndexOf('f');
            // attempt topic token first
            var test = token.substr(tPos + 1);

            // not sure why there's a comma here, but seems to sometimes...
            // see https://utteraccess.com/topics/2058884/posts/2777519
            test = stripAfterComma(test);
            if (!isNaN(test)) {
                ret = '/topics/' + test;

                if (to.query.pid && to.query.pid !== null) {
                    ret = ret + '/posts/' + to.query.pid;
                }
                if (to.query.p && to.query.p !== null) {
                    ret = ret + '/posts/' + to.query.p;
                }
                next(ret);
            }

            // try a board token instead
            test = token.substr(fPos + 1);
            if (!isNaN(test)) {
                ret = '/boards/' + test;
                next(ret);
            }

            next(ret);
        }},

        { path: '/wiki/index.php', component: Wiki },
        { path: '/wiki/', component: Wiki },
        { path: '/w/index.php', component: Wiki },
        { path: '/uploads/Crystal', redirect: '/' },
        { path: '*lowfiversion*', redirect: to => {
            // we're redirecting lowfi versions, but this link I found is going home instead:
            // /forum/lowfiversion/index.php/www.helenfeddema.com/t1889152.html
            return to.path.replace('lowfiversion/', '');
        }},
        //{ path: '*', redirect: '/'}
        {
            path: '*',
            beforeEnter(to, from, next)  {
                //console.log(to);
                //console.log(from);
                next('/');
            }
        }
    ]
});



function validateMemberEdit(to, from, next) {
  next();
    // let currentUserID = store.getters.user.id;
    // let paramID = parseInt(to.params.id)
    // if (currentUserID === paramID) {
    //     next()
    // } else {
    //     next(false);
    // }
}

//function getQuerystring(path) {
//    var i = path.indexOf('&');
//    if (i === -1) return '';
//    return path.slice(i + 1);
//}

function getParam(param) {
    // vue router "to.query" can be a single value or an array
    // if duplicates are sent, this will be an array, otherwise a single value
    // so, check if it's an array, and grab the first value, or just return the value if not an array
    if (!param) {
        return null;
    }
    if (Array.isArray(param)) {
        return param[0];
    } else {
        return param;
    }
}

function stripQuerystring(path) {
    var i = path.indexOf('&');
    if (i === -1) return path;
    return path.slice(0, i);
}
function stripAfterComma(path) {
    var i = path.indexOf(',');
    if (i === -1) return path;
    return path.slice(0, i);
}

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('token') != null) {
            next();
            return;
        }
        next('/login');
    } else {
        next();
    }
});


export default router;